export const getModuleMessages = async (locale: ApplicationLocale) => import(`@/modules/orders/locales/${locale}.json`);

export default getModuleMessages;
